import { HttpException, orthancHttp } from '../http';

export type OrthancSeriesId = string;

export async function findSeriesId(seriesInstanceUid: string): Promise<OrthancSeriesId | null> {
  const { data, status } = await orthancHttp.post<unknown>('tools/find', {
    Level: 'Series',
    Query: { SeriesInstanceUID: seriesInstanceUid },
  });

  if (!Array.isArray(data)) {
    throw new HttpException(
      status,
      `tools/find answered ${status} with a body that is not an array`
    );
  }

  const [first] = data;

  return typeof first === 'string' && first ? first : null;
}

export async function getSeriesLabels(orthancSeriesId: OrthancSeriesId): Promise<string[]> {
  const { data, status } = await orthancHttp.get<unknown>(
    `series/${encodeURIComponent(orthancSeriesId)}/labels`
  );

  if (!Array.isArray(data)) {
    throw new HttpException(
      status,
      `series labels answered ${status} with a body that is not an array`
    );
  }

  return data.filter((label): label is string => typeof label === 'string' && label.length > 0);
}

const ARCHIVE_TIMEOUT_MS = 5 * 60 * 1000;

export async function getSeriesArchive(orthancSeriesId: OrthancSeriesId): Promise<Blob> {
  const response = await orthancHttp.get<Blob>(
    `series/${encodeURIComponent(orthancSeriesId)}/archive`,
    { responseType: 'blob', timeout: ARCHIVE_TIMEOUT_MS }
  );
  return response.data;
}
